export { BsaBatchDetailsRoute } from './route'
